// stahlia-frontend/src/lib/inventur-form.ts
// FE-Spiegel der reinen Inventur-Regeln aus src/modules/warehouse/inventur-logic.ts
// (Spec-Merkliste ③, 2026-07-07) — Aenderungen IMMER an beiden Stellen nachziehen.

export type InventurMode = 'regal' | 'produkt' | 'voll'

export interface InventurScope {
  row_codes?: string[]
  merchant_skus?: string[]
  import?: Record<string, unknown>
}

export function validateScope(mode: InventurMode, scope: InventurScope): string | null {
  if (scope.import != null && (mode !== 'produkt' || !scope.merchant_skus?.length || scope.merchant_skus.some(s => !s.trim())))
    return 'Import-Inventur braucht Produkt-Modus und mindestens eine gültige Händler-Artikelnummer'
  if (mode === 'regal' && !(scope.row_codes && scope.row_codes.length > 0)) {
    return 'Regal-Modus braucht mindestens eine Regalreihe'
  }
  if (mode === 'produkt' && !(scope.merchant_skus && scope.merchant_skus.length > 0)) {
    return 'Produkt-Modus braucht mindestens eine Händler-Artikelnummer'
  }
  return null
}

/** Plausibilitäts-Warnung (③.10 Stufe 1): |Δ| >= max(10, 30 % vom Erwartungswert).
 *  Nie-Blockieren — der Aufrufer zeigt nur die Warnung, gespeichert wird immer. */
export function qtyWarning(expected: number, counted: number): string | null {
  const limit = Math.max(10, Math.ceil(expected * 0.3))
  if (Math.abs(counted - expected) >= limit) {
    return `Erwartet ~${expected}, gezählt ${counted} — sicher?`
  }
  return null
}
